import { DialogTitle, DialogContent, Grid, Typography, RadioGroup, Radio, FormControlLabel } from '@mui/material';
import { Alert } from '@mui/material';
import { useState, useEffect } from 'react';
import { RoundedDialog, StandardDialogActions } from '../Components';

export default function ImageSettingsDialog({ open, onClose, initial, onResult, forColumn }) {
  const [imageSize, setImageSize] = useState('');

  useEffect(() => {
    setImageSize(initial?.imageSize || forColumn ? 'small' : 'large');
  }, [initial, forColumn]);

  function done() {
    onResult({ imageSize });
    onClose();
  }

  return (
    <RoundedDialog open={open} onClose={onClose} maxWidth="xs" fullWidth className="non-draggable">
      <DialogTitle>Display settings</DialogTitle>
      <DialogContent>
        <Grid container gap={1}>
          <Grid container>
            <Typography variant="subtitle1">Image size on PDF:</Typography>
          </Grid>
          <Grid container>
            <RadioGroup value={imageSize} onChange={(e) => setImageSize(e.target.value)}>
              <FormControlLabel value={'large'} label={forColumn ? 'Large' : 'Large (default)'} control={<Radio />} />
              <FormControlLabel value={'medium'} label={'Medium'} control={<Radio />} />
              <FormControlLabel value={'small'} label={forColumn ? 'Small (default)' : 'Small'} control={<Radio />} />
            </RadioGroup>
          </Grid>
          {!forColumn && (
            <Grid container>
              <Alert severity="info">
                If the gallery setting is on, then the images will be the default gallery style
              </Alert>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <StandardDialogActions onDone={done} onClose={onClose} />
    </RoundedDialog>
  );
}
